import { h, Component } from 'preact';
import { ClickArea } from '../click-area';
import CrossCloseSvg from '../cross-close-svg';
import { ButtonBase } from '../button-base';

type Props = {
  _debug?: boolean;
  style?: h.JSX.CSSProperties;
  iconSize?: number;
  id?: string;
  iconColor?: string;
  iconStyle?: h.JSX.CSSProperties;
  onClick?: (e: Event) => void;
  onTouchStart?: (e: Event) => void;
  closingScheduledIn?: number;
  showClose?: boolean;
  clickCloseTime?: number;
  elapsedTime?: number;
};

type State = {
  visible?: boolean;
};

export class CloseThumbnailControl extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      visible: props.showClose
    };
  }

  render() {
    const {
      style,
      onTouchStart,
      onClick,
      _debug,
      iconSize,
      id,
      iconColor,
      iconStyle = {},
      closingScheduledIn,
      clickCloseTime = 0,
      elapsedTime = 0
    }: Props = this.props;

    if (!this.state.visible) {
      return <div />;
    }

    if (closingScheduledIn) {
      return (
        <div
          style={{
            color: iconColor,
            width: iconSize,
            height: iconSize,
            fontSize: iconSize,
            textAlign: 'center',
            lineHeight: '11px'
          }}
        >
          {Math.round(closingScheduledIn - (elapsedTime - clickCloseTime))}
        </div>
      );
    }

    return (
      <ButtonBase
        id="close-btn"
        data-zone="close_button"
        aria-label="ogury_close_button"
        style={{ display: 'inline-block' }}
      >
        <ClickArea onTouchStart={onTouchStart} onClick={onClick} debug={_debug}>
          <CrossCloseSvg
            id={id}
            size={iconSize}
            customStyle={iconStyle}
            color={iconColor}
          />
        </ClickArea>
      </ButtonBase>
    );
  }
}
